/* Contact page - form submit + reveal */
(() => {
  const reveals = document.querySelectorAll(".contact-reveal");
  if (reveals.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("is-in"));
  }

  const form = document.querySelector("[data-contact-form]");
  if (!form) return;

  const status = form.querySelector("[data-form-status]");
  const WA = "923114711112";
  const EMAIL = "mannacrockery8@gmail.com";

  function values() {
    const data = new FormData(form);
    return {
      name: String(data.get("name") || "").trim(),
      phone: String(data.get("phone") || "").trim(),
      email: String(data.get("email") || "").trim(),
      topic: String(data.get("topic") || "").trim(),
      message: String(data.get("message") || "").trim()
    };
  }

  function setInvalid(el, on) {
    el.classList.toggle("is-invalid", !!on);
  }

  function validate(v) {
    const nameEl = form.elements.namedItem("name");
    const phoneEl = form.elements.namedItem("phone");
    const topicEl = form.elements.namedItem("topic");
    const messageEl = form.elements.namedItem("message");
    const emailEl = form.elements.namedItem("email");

    let ok = true;
    setInvalid(nameEl, !v.name);
    if (!v.name) ok = false;
    setInvalid(phoneEl, !v.phone);
    if (!v.phone) ok = false;
    setInvalid(topicEl, !v.topic);
    if (!v.topic) ok = false;
    setInvalid(messageEl, !v.message);
    if (!v.message) ok = false;

    if (v.email && emailEl) {
      const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email);
      setInvalid(emailEl, !emailOk);
      if (!emailOk) ok = false;
    } else if (emailEl) {
      setInvalid(emailEl, false);
    }

    return ok;
  }

  function compose(v) {
    return [
      `Hello Manna Crockery,`,
      ``,
      `Name: ${v.name}`,
      `Phone: ${v.phone}`,
      v.email ? `Email: ${v.email}` : null,
      `Topic: ${v.topic}`,
      ``,
      v.message
    ].filter((line) => line !== null).join("\n");
  }

  function showStatus(text, isError) {
    if (!status) return;
    status.hidden = false;
    status.textContent = text;
    status.classList.toggle("is-error", !!isError);
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const viaEmail = e.submitter && e.submitter.hasAttribute("data-send-email");
    const v = values();
    if (!validate(v)) {
      showStatus("Please fill in the required fields.", true);
      return;
    }

    const body = compose(v);
    if (viaEmail) {
      const subject = encodeURIComponent(`Contact - ${v.topic}`);
      const mailto = `mailto:${EMAIL}?subject=${subject}&body=${encodeURIComponent(body)}`;
      window.location.href = mailto;
      showStatus("Opening your email app…", false);
      return;
    }

    const wa = `https://wa.me/${WA}?text=${encodeURIComponent(body)}`;
    window.open(wa, "_blank", "noopener,noreferrer");
    showStatus("Opening WhatsApp with your message…", false);
  });
})();
